'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

var fetcher = void 0;

if (typeof fetch === 'undefined') {
  fetcher = require('node-fetch');
} else {
  fetcher = fetch;
}

var Dymo = function () {
  function Dymo(options) {
    _classCallCheck(this, Dymo);

    options = options || {};
    this.hostname = options.hostname || 'localhost';
    this.port = options.port || 41951;
    this.printerName = options.printerName;
  }

  _createClass(Dymo, [{
    key: 'print',
    value: function print(printerName, labelXml, printParamsXml) {
      var label = 'printerName=' + encodeURIComponent(printerName) + '&printParamsXml=' + encodeURIComponent(printParamsXml) + '&labelXml=' + encodeURIComponent(labelXml) + '&labelSetXml=';

      if (typeof process !== 'undefined' && process.env) {
        process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0'; // TODO: Bundle the certificates.
      }

      return fetcher(this.apiUrl + '/PrintLabel', {
        method: 'POST',
        body: label,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        return response.text();
      }).then(function (result) {
        return result;
      });
    }
  }, {
    key: 'getPrinters',
    value: function getPrinters() {
      if (typeof process !== 'undefined' && process.env) {
        process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0'; // TODO: Bundle the certificates.
      }

      return fetcher(this.apiUrl + '/GetPrinters').then(function (response) {
        return response.text();
      });
    }
  }, {
    key: 'apiUrl',
    get: function get() {
      return 'https://' + this.hostname + ':' + this.port + '/DYMO/DLS/Printing';
    }
  }]);

  return Dymo;
}();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = Dymo;
} else {
  window.Dymo = Dymo;
}